import {createContext} from "react";

export const AlgoliaContext = createContext<string>("");
export const ThemeContext = createContext<"light" | "dark">("light");
export const PositionContext = createContext<"left" | "right">("right");
